__turbopack_context__.v({
  "button": "Form-module__pGM6Uq__button" + " " + "Form-module__pGM6Uq__focusOutline",
  "checkbox": "Form-module__pGM6Uq__checkbox" + " " + "Form-module__pGM6Uq__focusOutline",
  "disabled": "Form-module__pGM6Uq__disabled",
  "error": "Form-module__pGM6Uq__error",
  "errorBorder": "Form-module__pGM6Uq__errorBorder",
  "focusBorder": "Form-module__pGM6Uq__focusBorder",
  "focusOutline": "Form-module__pGM6Uq__focusOutline",
  "input": "Form-module__pGM6Uq__input" + " " + "Form-module__pGM6Uq__focusBorder",
  "inverse": "Form-module__pGM6Uq__inverse",
  "link": "Form-module__pGM6Uq__link" + " " + "Form-module__pGM6Uq__focusOutline",
  "primary": "Form-module__pGM6Uq__primary",
  "primaryColor": "Form-module__pGM6Uq__primaryColor",
  "primaryText": "Form-module__pGM6Uq__primaryText",
  "red": "Form-module__pGM6Uq__red",
  "select": "Form-module__pGM6Uq__select" + " " + "Form-module__pGM6Uq__focusBorder",
  "transparent": "Form-module__pGM6Uq__transparent",
});
